import { createSlice } from '@reduxjs/toolkit'

export const navSlice = createSlice({
    name: 'nav',
    initialState: { expanded: false },
    reducers: {
        setExpanded: (state, action) => {
            state.expanded = action.payload
        },
    },
    selectors: { selectExpanded: (state) => state.expanded },
})

export const { setExpanded } = navSlice.actions
export const { selectExpanded } = navSlice.selectors

export default navSlice.reducer
